<!--
 * @Author: Shber
 * @Date: 2023-05-05 14:27:54
 * @LastEditors: Shber
 * @LastEditTime: 2023-05-12 15:45:46
 * @Description:
-->
<template>
  <div class="find_home" style="background:#FAF5E6">
    <gc-loading :is-show="loading" />
    <div class="banner" style="background:url('https://static.mingchu.co/webapp/xintan/banner.png') no-repeat top center;">
      <span class="question_tip" @click="setRuleShow('活动规则')">  <i class="svg svg_question" /> 活动规则</span>
      <div :class="{'count_time':true, 'count_end':isActiveEnd}">
        <template v-if="isActiveEnd">
          <h4>挑战已结束，页面下方查看活动详情</h4>
          <div class="btn_list">
            <a v-if="data.server_time >= data.name_public_time" :href="goPrize()">获奖名单</a>
            <span v-else @click="noPrize">获奖名单</span>
            <a href="javascript:;" @click="goApp('trial_feedback', data.trial_id)">作品合集</a>
            <a href="#hot" class="hot">「名厨力」排行榜</a>
          </div>
        </template>
        <template v-else>
          <h3>线上活动倒计时</h3>
          <ul class="time_item">
            <li><p class="style_text fw400">{{ timeAll.day }}</p> <span>天</span> </li>
            <li><p class="style_text fw400">{{ timeAll.hour }}</p> <span>小时</span> </li>
            <li><p class="style_text fw400">{{ timeAll.minute }}</p> <span>分钟</span> </li>
            <li><p class="style_text fw400">{{ timeAll.second }}</p> <span>秒</span> </li>
          </ul>
        </template>
      </div>
    </div>
    <div class="user_card">
      <h3 class="fw500">Hi，<span class="user_name text_over">{{ data.nick_name }}</span> &nbsp; 师傅！</h3>
      <img class="user_pic" :src="data.head_pic_url" alt="user">
      <template v-if="isActiveEnd">
        <span class="hot">请查看上方活动获奖名单</span>
        <p><template v-if="data.is_sign">感谢您的参与，</template> 更多活动敬请期待！</p>
      </template>
      <template v-else>
        <span class="hot">您的排名 {{ data.sort }}</span>
        <p>打卡每日任务，参与试用挑战，冲刺「名厨力」排行榜，赢最终大奖</p>
        <ul class="xin_step">
          <li v-for="(item,i) in userStep" :key="i">
            <img :src="item.img" alt="img">
            <div :style="{'background-color': item.color}">
              <p class="fw500">{{ item.text }}</p>
              <span v-if="item.des">{{ item.des }}</span>
            </div>
          </li>
        </ul>
      </template>
    </div>
    <div v-if="!isActiveEnd" class="brown_content tab_content">
      <ul id="tab" ref="tabList" class="tab_list fw500">
        <li
          v-for="(tab,i) in tabInfo"
          :key="i"
          :class="{active:tab.value==tabActive}"
          @click="setTabChecked(tab)"
        >
          {{ tab.name }}
          <span v-if="!tab.isStart" class="svg svg_lock" />
        </li>
      </ul>
      <template v-if="tabActive == 0">
        <TaskTemp :data-info="data" :share-info="shareData" @onTrial="clickTrial" />
      </template>

      <template v-if="tabActive == 1">
        <TrialTemp :data-info="data" />
      </template>
    </div>
    <Ranking :data-info="data" />
    <BottomLogo />
  </div>
  <ActionSheet
    :rule-show="ruleShow"
    :rule-title="ruleTitle"
    @onCancel="ruleCancel"
  />
  <ShareInfo :share-info="shareData" />
</template>

<script setup>
import '@/style/scss/activity/findnew.scss'
import '@/style/scss/activity/xintan.scss'
// import { superLink } from '@/utils'
import { ref, onMounted, onUnmounted, watch, reactive } from 'vue'
import { Toast } from 'vant'
import config from '@/config/config.js'
import { goAppPage } from '@/utils'
import { get } from '@/api/ajax'

import ShareInfo from '@/components/shareInfo.vue'
import TaskTemp from '../components/TaskTemp.vue'
import TrialTemp from '../components/TrialTemp.vue'
import ActionSheet from '../components/ActionSheet'
import BottomLogo from '../components/BottomLogo'
import Ranking from '../components/Ranking.vue'
let timer = null
let data = reactive({
  server_time: 0,
  name_public_time: 0,
  ask_task: {}, // 每日问答
  news_task: [],
  user_task: [],
  trialFood: [],
  completion_food: [],
  day_task: [],
  rank: [],
  is_sign: 0 // 是否参加活动
}) // 页面需要的接口数据

let shareData = reactive({ share_title: '', share_desc: '', share_img: '', share_link: '' })
const pageHide = ref(false) // 页面是否隐藏
const loading = ref(true)
const tabList = ref(null)
const isActiveEnd = ref(false)
const ruleShow = ref(false)
const ruleTitle = ref('常见问题')
const timeInterval = ref(null)
const timeAll = ref({ day: '00', hour: '00', minute: '00', second: '00' })
const userStep = reactive([
  { img: 'https://static.mingchu.co/webapp/xintan/icon1.png', text: '1位 杭州米其林指南发布庆典门票', des: '「名厨力」排名靠前且试用作品最优的用户', color: '#D6E3F4' },
  { img: 'https://static.mingchu.co/webapp/xintan/icon2.png', text: '6位 探访杭州新晋米其林餐厅', des: '「名厨力」排名靠前，作品多、热度高的用户', color: '#FAE5B7' },
  { img: 'https://static.mingchu.co/webapp/xintan/icon3.png', text: '前10名 获得名厨MINGCHU周边', des: '「名厨力」排名前10的用户', color: '#C4EECA' }
])
const tabActive = ref(0) // tab选中状态
const tabInfo = reactive([
  { name: '我的任务', value: 0, isStart: true },
  { name: '试用挑战', value: 1, isStart: false }
])

const handleVisibilityChange = () => {
  pageHide.value = document.hidden
}
watch(pageHide, (newVal, oldVal) => {
  if (!newVal) {
    Toast.loading({
      message: 'Loading...',
      forbidClick: true
    })
    getDataList()
  }
})

onMounted(() => { // 监听页面显示隐藏
  document.addEventListener('visibilitychange', handleVisibilityChange)
})
onUnmounted(() => {
  document.removeEventListener('visibilitychange', handleVisibilityChange)
  clearTimeout(timer)
})

const clickTrial = (_status) => {
  setTabChecked(tabInfo[1])
  tabList.value.scrollIntoView()
}

const setNum = (num) => {
  return num < 10 ? '0' + num : num
}

const resetTime = (countTime) => {
  let day = Math.floor(countTime / (60 * 60 * 24))
  let hour = Math.floor(countTime / (60 * 60) % 24)
  let minute = Math.floor(countTime / 60 % 60)
  let second = Math.floor(countTime % 60)
  // 给一位数 补0
  day = setNum(day)
  hour = setNum(hour)
  minute = setNum(minute)
  second = setNum(second)
  timeAll.value = { day, hour, minute, second }
}

const getDataList = () => {
  clearInterval(timeInterval.value)
  get('/api/explore/detail').then(res => {
    console.log(res)
    if (res.code === 1) {
      data = res.data
      let countTime = (res.data.end_time - res.data.server_time)
      // isActiveEnd.value = true
      isActiveEnd.value = res.data.server_time >= res.data.end_time
      tabInfo[1].isStart = res.data.score >= 200
      shareData.share_link = `${config.webapplink}/riseActivity/xintan/xinshare?id=${res.data.user_id}`
      // 如果倒计时结束，停掉计时器
      if (countTime >= 0) {
        timeInterval.value = setInterval(() => {
          countTime -= 1
          resetTime(countTime)
          if (countTime <= 0) {
            clearInterval(timeInterval.value)
          }
        }, 1000)
      } else {
        clearInterval(timeInterval.value)
        isActiveEnd.value = true
      }
    } else {
      Toast(res.message)
    }
    timer = setTimeout(() => { loading.value = false }, 300)
  }).finally(() => {
    Toast.clear()
  })
}

const getShareData = () => {
  get('/api/explore/share_info').then(res => {
    if (res.code === 1) {
      shareData = res.data
      getDataList()
    } else {
      Toast(res.message)
    }
  })
}
getShareData()

const setTabChecked = ({ isStart, value }) => {
  if (isStart) {
    tabActive.value = value
  } else {
    Toast('快去完成任务，当「名厨力」超过200分，即可参与试用挑战。')
  }
}

const ruleCancel = () => {
  ruleShow.value = false
}
const setRuleShow = (title) => {
  ruleTitle.value = title
  ruleShow.value = true
}
const goApp = (_des, _id) => {
  const param = `{
          "des": "${_des}",
          "skuid": "${_id}"
        }`
  goAppPage(param)
}

const noPrize = () => {
  Toast('获奖名单暂未公布')
}
const goPrize = () => {
  return `${config.webapplink}/newsview?id=${data.public_news_id}`
}

// const goPath = (_des, _skuid) => {
//   const data = `{
//           "des": "${_des}",
//           "skuid": "${_skuid}",
//           "link": "${config.webapplink}/${_des}?id=${_skuid}"
//         }`
//   return superLink(data)
// }

</script>
